import FloatingAction from "../../components/common/FloatingAction";
import UserFooter from "../../components/common/UserFooter";
import UserNavbar from "../../components/common/UserNavbar";

const UserLayout = (props) => {
  return (
    <main className="relative lg:max-w-[2080px] lg:mx-auto w-full">
      <UserNavbar />
      {props.children}

      <UserFooter />
      <FloatingAction />
    </main>
  );
};

export default UserLayout;
